var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass:
        "\n    fill-height\n    max-width\n    pa-0\n    d-flex\n    flex-row flex-grow-1\n    justify-space-between\n  ",
      attrs: { fluid: "" },
    },
    [
      _c("div", { staticClass: "max-width text-start pl-2" }, [
        _c(
          "div",
          { class: _vm.year.indexOf("-") != -1 ? "caption" : "body-2" },
          [_vm._v(" " + _vm._s(_vm.year) + " ")]
        ),
        _c(
          "div",
          { staticClass: "title font-weight-black text-block text-truncate" },
          [_vm._v(" " + _vm._s(_vm.month) + " ")]
        ),
        _c(
          "div",
          { staticClass: "max-width d-flex mt-1" },
          [
            _vm.isEdited
              ? _c("v-checkbox", {
                  staticClass: "mt-0 pt-0 ml-n1",
                  staticStyle: { pointer: "cursor" },
                  attrs: {
                    ripple: false,
                    color: _vm.isHalf ? "grey" : "",
                    readonly: false,
                    indeterminate: _vm.isHalf,
                  },
                  model: {
                    value: _vm.checked,
                    callback: function ($$v) {
                      _vm.checked = $$v
                    },
                    expression: "checked",
                  },
                })
              : _vm._e(),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "label_essweb_RosterFormRecord_form_table_staffNameLabbel"
                  )
                )
              ),
            ]),
            _c("v-spacer"),
            0
              ? _c("v-btn", { attrs: { icon: "" } }, [
                  _c("span", { staticClass: "material-icons-round" }, [
                    _vm._v("more_vert"),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }